import { render } from "./CreateUser.vue?vue&type=template&id=962f2ad8&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=962f2ad8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-962f2ad8"

export default script